module.exports = __webpack_public_path__ + "assets/img/李岳彪-code.28827a3e.jpg";